import { render, staticRenderFns } from "./RepositoriesTree.vue?vue&type=template&id=1f823289&scoped=true&"
import script from "./RepositoriesTree.vue?vue&type=script&lang=js&"
export * from "./RepositoriesTree.vue?vue&type=script&lang=js&"
import style0 from "./RepositoriesTree.vue?vue&type=style&index=0&id=1f823289&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f823289",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f823289')) {
      api.createRecord('1f823289', component.options)
    } else {
      api.reload('1f823289', component.options)
    }
    module.hot.accept("./RepositoriesTree.vue?vue&type=template&id=1f823289&scoped=true&", function () {
      api.rerender('1f823289', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/RepositoriesTree.vue"
export default component.exports